import { NEW_PLAN_ID_PREFIX } from '@provision/service-level-utils';
import type {
  PlanPlatformSlaValue,
  PlansTabBrandingValues,
  PlansTabFaqQuestionValues,
  PlansTabFeatureValues,
  PlansTabFormValues,
  PlansTabPlanValues,
} from 'src/pages/Settings/memberships/components/plans-tab/types';

export const DEFAULT_BRANDING_VALUES: PlansTabBrandingValues = {
  primaryColor: '#2563eb',
  secondaryColor: '#2563eb',
  bannerColor: '#2563eb',
  pageBlock1Color: '#f9fafb',
  backgroundImageUrl: '',
};

export const NO_PLATFORM_SLA_OPTION = { id: '', label: 'No SLA' } as const;

export const resolvePlatformSlaId = (
  value: PlanPlatformSlaValue | undefined,
): string | null => {
  if (!value) {
    return null;
  }

  const id = typeof value === 'string' ? value : String(value.id ?? '');

  return id.trim() || null;
};

let newPlanSequence = 0;

export const nextNewPlanKey = (): string => `${NEW_PLAN_ID_PREFIX}${++newPlanSequence}`;

export const createNewPlan = (
  sortOrder = 0,
  id: string = nextNewPlanKey(),
): PlansTabPlanValues => ({
  id,
  name: 'New Plan',
  enabled: true,
  mostPopular: false,
  callForPricing: false,
  monthlyPrice: '',
  annualPrice: '',
  sortOrder,
  platformSlaId: null,
});

export const createNewFeature = (sortOrder = 0): PlansTabFeatureValues => ({
  id: crypto.randomUUID(),
  name: '',
  defaultContent: '',
  defaultTooltip: '',
  includedPlanIds: [],
  overrideContentByPlanId: {},
  overrideTooltipByPlanId: {},
  sortOrder,
});

export const createNewFaqQuestion = (sortOrder = 0): PlansTabFaqQuestionValues => ({
  id: crypto.randomUUID(),
  question: '',
  answer: '',
  sortOrder,
});

export const DEFAULT_PLANS_TAB_VALUES: PlansTabFormValues = {
  billingOptions: {
    monthlyEnabled: true,
    annualEnabled: true,
  },
  plans: [],
  features: [],
  options: {
    showFaq: false,
    faqQuestions: [],
    showSkipPriceSelection: false,
    requireTosBeforePlans: false,
    setupCheckoutText: '',
    showContactSupport: false,
    contactSupportLink: '',
    branding: { ...DEFAULT_BRANDING_VALUES },
  },
};
